import { Activity } from "lucide-react";
import { AppStoreButton } from "@/components/AppStoreButton";

const links = [
  { href: "#benefits", label: "Benefits", testId: "nav-link-benefits" },
  { href: "#simulator", label: "Simulator", testId: "nav-link-simulator" },
  { href: "#reviews", label: "Reviews", testId: "nav-link-reviews" },
  { href: "#rate", label: "How to Rate", testId: "nav-link-rate" },
];

export const Navbar = () => (
  <header
    data-testid="navbar"
    className="fixed top-0 inset-x-0 z-50 flex items-center justify-between px-4 sm:px-8 py-3.5 backdrop-blur-xl bg-[#070C18]/85 border-b border-white/10"
  >
    <a href="#top" data-testid="nav-brand" className="flex items-center gap-2.5">
      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-400/15 border border-sky-400/30">
        <Activity className="h-5 w-5 text-sky-400" />
      </span>
      <span className="font-bold tracking-tight text-white">Payment Pulse</span>
    </a>
    <nav className="hidden md:flex items-center gap-7">
      {links.map((l) => (
        <a
          key={l.href}
          data-testid={l.testId}
          href={l.href}
          className="text-sm text-slate-300 hover:text-white transition-colors duration-200"
        >
          {l.label}
        </a>
      ))}
    </nav>
    <AppStoreButton testId="nav-appstore-button" size="sm" />
  </header>
);
